<template>
  <div class="position-relative report-view"
    :style="'font-family: ' + this.selected_report.font_family + '; font-size: ' + this.selected_report.font_size + 'px;'">
    
    <arrow-button class="d-block d-print-none"/>
    <SearchResult class="d-block d-print-none" v-if="showSearchResult" :query="searchQuery" />
    <!-- story_board/print_mode를 통해 불필요하게 pdf출력 컴포넌트가 렌더링되는 것을 방지 -->
      <div v-if="print_mode" class="d-none d-print-block position-absolute w-100">
        <div id="full-report-preview-sb">
          <PdfMain :mp4Url="mp4Url" :imageUrl="imageUrl"></PdfMain>
          <PdfIndex :sb_toc="sb_toc" :selectedLv1PrintOption="selectedLv1PrintOption"></PdfIndex>
          <div 
            v-for="(lv1_info, lv1_idx) in selectedLv1PrintOption" 
            :class="(((lang !== 'ENG' 
            ? lv1_info.name 
            : (lv1_info.name_em || lv1_info.name_ea)
              ) || '')
              .trim()
              .replace(/[\n\r]+/g, '')
              .replace(/\s+/g, '_')
            )"
            :key="'nav_lv1' + lv1_idx" 
          >
            <!-- lv1 cover -->
            <template v-if="
              !selectedLv1PrintOption ||
              selectedLv1PrintOption.length === 0 ||
              selectedLv1PrintOption.map(lv1_info => lv1_info.key).includes(lv1_info?.key)
            ">
              <WaterMark v-if="selected_report.sample_report" />
              <div :id="'sb_cover_lv1_' + lv1_info.key" v-for="(lv2_info, lv2_idx) in lv1_info.children"
                :key="'nav_lv2' + lv2_idx">
                <Cover class="new-page page-no-break-after page-content" :data-page-info="lv1_info.name" v-if="
                  lv2_info.appendix_type === null || report_types.includes(lv2_info.appendix_type)
                " :lv1_info="lv1_info" :lv2_info="lv2_info" :background_color="lv1_info.background_color" />
                  <div class="page-no-break-before print-margin">
                    <template v-if="viewer_disclosure_map && viewer_disclosure_map[lv1_info?.key]">
                      <Content v-if="lv2_info?.appendix_type === null" class="pt-4"
                        :disclosures="viewer_disclosure_map[lv1_info.key][lv2_info.key]" :print_mode="true" 
                        :is_appendix="selected_lv1?.name === 'Appendix'"/>

                      <template v-else-if="lv2_info?.appendix_type === 'ASSURANCE' && report_types.includes(lv2_info.appendix_type)">
                          <ViewAssuranceStatement  />
                      </template>
                      
                      <template v-else>
                        <GriTable v-if="
                          lv2_info?.appendix_type === 'GRI' &&
                          report_types.includes(lv2_info.appendix_type)
                        " :print_mode="true" />
                        <SASBTable v-else-if="
                          lv2_info?.appendix_type === 'SASB' &&
                          report_types.includes(lv2_info.appendix_type)
                        " :print_mode="true" />
                        <TCFDTable v-else-if="
                          lv2_info?.appendix_type === 'TCFD' &&
                          report_types.includes(lv2_info.appendix_type)
                        " :print_mode="true" />
                        <DataCenterTableSb v-else-if="selected_lv2?.appendix_type === 'DATACENTER'" :print_mode="true" />
                      </template>
                    </template>
                  </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="d-block d-print-none w-100">
        <div class="d-flex justify-content-center w-100">
          <Nav />
        </div>

        <transition :name="view_mode === 'viewer' ? 'fade' : ''">
          <div :key="selected_lv2 ? selected_lv2.key : 'default-key'">
            <div class="d-flex flex-column align-items-center">
              <WaterMark v-if="selected_report.sample_report" />
              <Cover :lv1_info="selected_lv1" :lv2_info="selected_lv2" class="w-100" />
              <template v-if="selected_lv1 === null">
                <Main />
              </template>
              
              <div v-if="!selected_lv2?.appendix_type" class="padded-container w-100">
                <b-row v-if="selected_lv1 !== null" class="justify-content-center justify-content-lg-between  pt-5">
                  <template v-if="selected_lv2?.show_nav">
                    <b-col class="d-none d-lg-block" cols="0" lg="3" xl="2">
                      <StoryBoardTocViewer 
                        :disclosures="selected_viewer_disclosures" 
                        :class="{
                          'side-nav3':
                          selected_lv2 && selected_lv2.children && selected_lv2.children.length > 0,
                        }" 
                      />
                    </b-col>
                    <b-col id="content" cols="12" lg="9" xl="8">
                      <Content 
                        v-if="selected_viewer_disclosures && selected_lv2?.key"
                        :disclosures="selected_viewer_disclosures" 
                      />

                      <template v-else>
                        <div class="mb-5 vh-adjust">
                          <!-- 로딩뷰 -->
                          <div>
                            <span class="mt-5"></span>
                            <h5 class="mb-4 border-bottom-dark pb-2">
                              <span class="gray-500 f-105 fw-400 ml-1">
                                <b-skeleton animation="wave" width="20%"></b-skeleton>
                                <b-skeleton type="button"></b-skeleton>
                              </span>
                            </h5>
                          </div>
                          <b-skeleton animation="fade" width="85%"></b-skeleton>
                          <b-skeleton animation="fade" width="55%"></b-skeleton>
                          <b-skeleton animation="fade" width="80%"></b-skeleton>
                          <b-skeleton animation="fade" width="30%"></b-skeleton>
                          <b-skeleton animation="fade" width="40%"></b-skeleton>
                          <br />
                          <b-skeleton animation="fade" width="40%"></b-skeleton>
                          <b-skeleton animation="fade" width="20%"></b-skeleton>
                        </div>
                      </template>
                    </b-col>
                    <b-col class="d-none d-lg-block invisible" cols="0" xl="2"> </b-col>
                  </template>

                  <template v-else>
                    <b-col class="d-none d-lg-block invisible" cols="0" lg="1" xl="2"> 

                    </b-col>
                    <b-col id="content" cols="12" lg="10" xl="8">
                      <Content v-if="selected_viewer_disclosures && selected_lv2?.key"
                        :disclosures="selected_viewer_disclosures" />
                    </b-col>
                    <b-col class="d-none d-lg-block invisible" cols="0" lg="1" xl="2">
                       </b-col>
                  </template>
                </b-row>
              </div>
              <div v-else class="padded-container w-100">
                <b-row v-if="selected_lv1 === null">
                  <Main />
                </b-row>
                <b-row v-else
                  class="justify-content-center justify-content-lg-between border-lg pt-5">

                  <template v-if="selected_lv2?.appendix_type === 'GRI'">
                    <b-col class="d-none d-lg-block" cols="0" lg="1" xl="2">
                    </b-col>
                    <b-col id="content" cols="12" lg="10" xl="8">
                      <GriTable  />
                    </b-col>
                    <b-col class="d-none d-lg-block invisible" cols="0" lg="1" xl="2">
                    </b-col>
                  </template>

                  <template v-else-if="selected_lv2?.appendix_type === 'ASSURANCE'">
                    <b-col class="d-none d-lg-block" cols="0" lg="1" xl="2">
                    </b-col>
                    <b-col id="content" cols="12" lg="10" xl="8">
                      <ViewAssuranceStatement  />
                    </b-col>
                    <b-col class="d-none d-lg-block invisible" cols="0" lg="1" xl="2">
                    </b-col>
                  </template>

                  <template v-else>
                    <b-col class="d-none d-lg-block" cols="0" lg="3" xl="2">
                      <!-- GRI, SASB, TCFD인 경우 목차 필요 -->
                      <SASBTocViewer v-if="selected_lv2?.appendix_type === 'SASB'"
                        class="side-nav3" />
                      <TCFDTocViewer v-else-if="selected_lv2?.appendix_type === 'TCFD'"
                        class="side-nav3" />
                      <DCTocViewer v-else-if="selected_lv2?.appendix_type === 'DATACENTER'"
                        class="side-nav3" />
                    </b-col>
  
                    <b-col id="content" cols="12" lg="9" xl="8">
                      <SASBTable v-if="selected_lv2?.appendix_type === 'SASB'" 
                        :business_case_mode="theme_option !== null ? theme_option.theme_info?.business_case_mode : ''"
                        :table_mode="theme_option !== null ? theme_option.theme_info?.table_mode : ''"
                        :material_style_option="theme_option !== null ? theme_option.theme_info?.material_style_option : ''"
                        :table_style="theme_option !== null ? theme_option.theme_info?.table_style : ''"
                        :show_table_line="theme_option !== null ? theme_option.theme_info?.show_table_line : ''"
                        :show_table_outline="theme_option !== null ? theme_option.theme_info?.show_table_outline : ''"
                        :table_header_color="theme_option !== null ? theme_option.theme_info?.table_header_color : ''"
                        :table_header_font_color="
                          theme_option !== null ? theme_option.theme_info?.table_header_font_color : ''
                        "/>
                      <TCFDTable v-else-if="selected_lv2?.appendix_type === 'TCFD'" 
                        :business_case_mode="theme_option !== null ? theme_option.theme_info?.business_case_mode : ''"
                        :table_mode="theme_option !== null ? theme_option.theme_info?.table_mode : ''"
                        :material_style_option="theme_option !== null ? theme_option.theme_info?.material_style_option : ''"
                        :table_style="theme_option !== null ? theme_option.theme_info?.table_style : ''"
                        :show_table_line="theme_option !== null ? theme_option.theme_info?.show_table_line : ''"
                        :show_table_outline="theme_option !== null ? theme_option.theme_info?.show_table_outline : ''"
                        :table_header_color="theme_option !== null ? theme_option.theme_info?.table_header_color : ''"
                        :table_header_font_color="
                          theme_option !== null ? theme_option.theme_info?.table_header_font_color : ''
                        "/>
                      <DataCenterTableSb v-else-if="selected_lv2?.appendix_type === 'DATACENTER'" 
                        :business_case_mode="theme_option !== null ? theme_option.theme_info?.business_case_mode : ''"
                        :table_mode="theme_option !== null ? theme_option.theme_info?.table_mode : ''"
                        :material_style_option="theme_option !== null ? theme_option.theme_info?.material_style_option : ''"
                        :table_style="theme_option !== null ? theme_option.theme_info?.table_style : ''"
                        :show_table_line="theme_option !== null ? theme_option.theme_info?.show_table_line : ''"
                        :show_table_outline="theme_option !== null ? theme_option.theme_info?.show_table_outline : ''"
                        :table_header_color="theme_option !== null ? theme_option.theme_info?.table_header_color : ''"
                        :table_header_font_color="
                          theme_option !== null ? theme_option.theme_info?.table_header_font_color : ''
                        "/>
                    </b-col>
                    <b-col class="d-none d-lg-block invisible" cols="0" xl="2">
                    </b-col>
                  </template>
                </b-row>
              </div>
            </div>
            <div class="d-flex justify-content-center w-100 bgray-1000" :style="{ marginTop: selected_lv1 === null ? '0' : '10rem' }">
              <custom-footer />
            </div>
          </div>
        </transition>
      </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import Nav from '@/components/report_preview/story_board/viewer_component/Nav';
import Cover from '@/components/report_preview/story_board/viewer_component/Cover';
import Content from '@/components/report_preview/story_board/viewer_component/Content';
import ContentPrint from '@/components/report_preview/story_board/viewer_component/ContentPrint';
import Main from '@/components/report_preview/story_board/main/index';
import StoryBoardTocViewer from './StoryBoardTocViewer';
import customFooter from './footer/custom-footer.vue';

import GriTable from '@/components/report_preview/gri2021_viewer/viewer_components/GRITable2021.vue';
import SASBTable from '@/components/report_preview/gri2021_viewer/viewer_components/SASBTable.vue';
import TCFDTable from '@/components/report_preview/gri2021_viewer/viewer_components/TCFDTable.vue';

import WaterMark from '@/components/report_preview/gri2021_viewer/WaterMark';
import SASBTocViewer from '../appendix_subs/SASBTocViewer.vue';
import TCFDTocViewer from '../appendix_subs/TCFDTocViewer.vue';
import DCTocViewer from '../appendix_subs/DCTocViewer.vue';
import DataCenterTableSb from '../gri2021_viewer/viewer_components/DataCenterTableSb.vue';

import ArrowButton from '../gri2021_viewer/viewer_components/contents_list_new/ArrowButton.vue';
import PdfMain from './main/PdfMain.vue';
import PdfIndex from './main/PdfIndex.vue';
import ViewAssuranceStatement from '../appendix_subs/ViewAssuranceStatement.vue';
import SearchResult from '@/components/search_bar/SearchResult.vue';

export default {
  name: 'StoryBoardViewer',
  props: {},
  components: {
    Nav,
    Cover,
    Content,
    ContentPrint,
    Main,
    StoryBoardTocViewer,
    customFooter,
    WaterMark,
    SASBTable,
    TCFDTable,
    SASBTocViewer,
    TCFDTocViewer,
    DCTocViewer,
    DataCenterTableSb,
    ArrowButton,
    GriTable,
    ViewAssuranceStatement,
    SearchResult, 
    PdfMain,
    PdfIndex,
  },
  computed: {
    ...mapState('assurance', ['assurance_status']),
    ...mapState('report_contents', ['theme_option']),
    ...mapState('report_list', ['lang', 'view_mode']),
    ...mapGetters(['is_viewer']),
    ...mapGetters('report_list', ['selected_report', 'current_report_code']),
    ...mapGetters('story_board', ['sb_toc', 'selected_lv1', 'selected_lv2','selected_viewer_disclosures']),
    ...mapState('story_board', [
      'selectedLv1PrintOption',
      'viewer_sb_toc',
      'editor_sb_toc',
      'viewer_disclosure_map',
      'print_mode'
    ]),
    isRestoring() {
      return this.$store.state.isRestoring;
    },
  
    ...mapGetters('assurance', ['latest_assurance']),

    report_types() {
        const user_selected_report_type = Object.keys(this.selected_report.report_type).map(
          (item) => item.split('v')[0]
        );
        if (this.latest_assurance) {
          user_selected_report_type.push('ASSURANCE');
        }

        if (this.selected_report?.data_center) {
          user_selected_report_type.push('DATACENTER');
        }
        return user_selected_report_type;
      },
    imageUrl() {
        if (this.theme_option?.sb_theme_info?.unsplash_url) {
          return this.theme_option?.sb_theme_info?.unsplash_url;
        } else {
          return this.theme_option?.sb_theme_info?.main_cover_img_path
            ? this.$store.state.static_host + this.theme_option?.sb_theme_info?.main_cover_img_path
            : null;
        }
      },
      mp4Url() {
        return this.theme_option?.sb_theme_info?.main_cover_mp4_path
          ? this.$store.state.static_host + this.theme_option?.sb_theme_info?.main_cover_mp4_path
          : null;
      },
  },
  data() {
    return {
      disclosures: null,
      showSearchResult: false,
      searchQuery: '',
    };
  },
  created() {
  },
  beforeDestroy() {
    this.change_lang('KOR');
      
  },
  watch: {
    current_report_code: {
      immediate: true,
      handler(new_report_code, old_report_code) {
        if (new_report_code != old_report_code) {
        // if (this.selected_viewer_disclosures===null || (new_report_info.report_code !== undefined && new_report_info.report_code !== old_report_info.report_code)) {
          if (this.viewer_sb_toc === '' || this.editor_sb_toc === '') {
            localStorage.clear();
            window.location.reload();
          }

          if (this.is_viewer) {
            this.update_view_mode('viewer');
            this.fetch_sb_toc({ report_code: new_report_code, select_lv: false });
            this.fetch_viewer_sb_disclosures({ report_code: new_report_code });
          } else {
            this.update_view_mode('editor');

            this.fetch_viewer_sb_disclosures({
              report_code: new_report_code,
              selected_lv_info: {
                lv1_info: this.selected_lv1,
                lv2_info: this.selected_lv2
              }
            });
          }

          if (!process.env.VUE_APP_REPORT_CODE) {
            this.prune_viewer_disclosure_map(new_report_code)
          }
          this.fetch_main_setting_from_viewer({ report_code: new_report_code });

        }
      },
    },
    $route: {
      immediate: true,
      handler(to) {
        // 미리보기 렌더링 보완
        if (!to.path.includes('/report_preview')) {
          return;
        }

          try {
            
            const decodeKey = key => key.replace(/%20/g, ' ').replace(/%0A/g, '\n');

            const { lv1: lv1Key, lv2: lv2Key } = to.query;
            
            if (lv1Key) {
              const lv1_info = this.sb_toc.find(item => decodeKey(item.name) === lv1Key || item.key === lv1Key);
              if (lv1_info) {
                if (lv1_info.key !== this.selected_lv1?.key) {
                  this.update_selected_lv1({ 
                    lv1_info: lv1_info,
                    view_mode: this.viewer? 'viewer': 'editor'
                  });
                }
                if (lv2Key) {
                  const lv2_info = lv1_info.children.find(item => decodeKey(item.name) === lv2Key || item.key === lv2Key);
                  if (lv2_info) {
                    if (lv2_info.key !== this.selected_lv2?.key) {
                      this.update_selected_lv2({ 
                        lv2_info: lv2_info,
                        view_mode: this.viewer? 'viewer': 'editor'
                      });
  
                      this.fetch_viewer_sb_disclosures({
                        report_code: this.current_report_code,
                        selected_lv_info: {
                          lv1_info: lv1_info,
                          lv2_info: lv2_info
                        }
                      });

                    } else {
                      return;
                    }
                  }
                }
              }
            } else {
                this.update_selected_lv1(null);
                this.update_selected_lv2(null);
            }
          } catch (error) {
            console.log(error)
          }
        }
      },
  },
  methods: {
    ...mapMutations('report_list', ['change_lang', 'update_view_mode']),
    ...mapMutations('story_board', ['update_selected_lv1', 'update_selected_lv2', 'prune_viewer_disclosure_map']),
    ...mapActions('report_list', ['checkReportPublish', 'readAllReportListForViewer']),
    ...mapActions('assurance', ['readAssuranceStatusByReportCode']),
    ...mapActions('story_board', ['fetch_sb_toc','fetch_main_setting_from_viewer', 'fetch_viewer_sb_disclosures']),
  

  },
};
</script>

<style scoped>
.report-view {
  font-family: 'Pretendard';
}

.side-nav3 {
  border-left: 2px solid #d9d9d9;
}

/* 인쇄 스타일 */
  
  ::v-deep(.fade-enter-active),
  ::v-deep(.fade-leave-active) {
    transition: opacity 0.3s ease-in-out;
  }
  ::v-deep(.fade-enter),
  ::v-deep(.fade-leave-to) {
    opacity: 0;
  }
</style>
